import axios from '../config/axiosConfig';
import { BASE_URL } from './constant/BaseApiUrl';

export default class SubmitWorksheetService {
  handleSubmit(payload: any, id: any) {
    return axios.put(`${BASE_URL}quotes/${id}`, payload);
  }

  updatePassengers(payload: any, id: any) {
    return axios.put(`${BASE_URL}quotes/${id}/passenger`, payload);
  }

  updateRohRoom(payload: any) {
    return axios.put(`${BASE_URL}quotes/update-roh-room`, payload);
  }
}
